import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Client, EntityWithTemplate, Job, JobBoardPageComponent } from '@interfaces';
import { PaginatorComponent } from 'src/app/page-components/paginator/paginator.component';
import { PagedResponse } from 'src/app/rest/rest.service';
import { SubdomainService } from 'src/app/rest/subdomain.service';
import { JobCardHuskComponent } from '../job-card-husk/job-card-husk.component';
import { JobCardComponent } from '../job-card/job-card.component';

@Component({
	selector: 'app-jobs-list',
	templateUrl: './jobs-list.component.html',
	standalone: true,
	imports: [CommonModule, PaginatorComponent, JobCardComponent, JobCardHuskComponent]
})
export class JobsListComponent implements OnInit, OnChanges {
	@Input() loading = true;
	@Input() query = {};
    @Input() entity: EntityWithTemplate;
	@Input() component: JobBoardPageComponent;
	@Input() jobs: PagedResponse<Job> = {
		data: [],
		total: 0,
		pageIndex: 0,
		pageSize: 10
	};
	@ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
	public length = 0;
	public pageSize = 10;
	public pageSizeOptions = [3, 5, 10, 20];
	public client: Client;

	constructor(
		public route: ActivatedRoute,
		private subdomain: SubdomainService,
	) { }

	ngOnInit() {

		this.subdomain.getClient().subscribe(client => {
			this.client = client;
		});
	}

	ngOnChanges() {
		this.pageSize = this.route.snapshot.queryParams?.$limit || this.component?.resultsPerPage;
		this.length = this.jobs?.total || 0;
	}

}
